import { render, staticRenderFns } from "./value-difference.vue?vue&type=template&id=9827632e&scoped=true&"
import script from "./value-difference.vue?vue&type=script&lang=js&"
export * from "./value-difference.vue?vue&type=script&lang=js&"
import style0 from "./value-difference.vue?vue&type=style&index=0&id=9827632e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9827632e",
  null
  
)

export default component.exports